import { RxFormFieldDefs } from "components/rx-form";
import { ValidatorArgs, ValidatorRuleResult } from "components/validators"
import { Specification, SpecFile } from "common/api/Forms";
import { FileInfo } from "components/controls/file-uploader/FileInfo";



const validateUploadedFiles = (fileSpec: SpecFile) => (name: string, values: { [key: string]: any }, args: ValidatorArgs) => {

    const result: ValidatorRuleResult = {};

    if (name === 'plne_moci' && values['typ_hlasovani'] !== "1") {
        return result;
    }

    if (name === 'doklad_totoznosti' && values['typ_hlasovani'] !== "1") {
        return result;
    }

    let files: Array<FileInfo> = [];
    if (values[name] !== undefined) {
        files = values[name] as Array<FileInfo>;
    }

    if (fileSpec !== undefined) {
        if (fileSpec.min !== undefined && files.length < fileSpec.min) {
            result[name] = "Vložte potřebný soubor(y).";
        }
        if (fileSpec.max !== undefined && files.length > fileSpec.max) {
            result[name] = `Max. počet souborů je ${fileSpec.max}`;
        }
    }

    return result;
}


const buildFormFields = (spec: Specification) => {

    const result: RxFormFieldDefs = {};

    result['completed'] = { label: 'completed', defaultValue: false };

    spec.fields.forEach(f => {

        result[f.name] = f;

        switch (f.name) {
            case 'doklad_totoznosti':
                f.validate = { files: validateUploadedFiles(f.file) };
                break;

            case 'typ_hlasovani':
                f.placeholder = "- vyberte -";
                f.validate = { required: { msg: 'Vyberte jednu z možností.' } };
                break;

            case 'plne_moci':
                f.validate = { files: validateUploadedFiles(f.file) };
                break;
            case 'volba_delegatu':
                f.validate = { required: { msg: 'Vyberte delegáta(y).' } };
                break;

            case 'pocet_hlasu':
                f.placeholder = "zadejte počet hlasů";
                break;
        }
    });

    return result;
}


export default buildFormFields;